import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { NTH_USER_AUTO_FOLLOW_SPACES } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';
import { preloadFeatureDiscovery } from './preloadFeatureDiscovery';

export const preloadAutoFollowSpacesState = () => {
	return waitForAllReturnWhenError([
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: getOnboardingStateGQL,
			variables: {
				key: [NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES],
			},
		}),
		preloadFeatureDiscovery(),
	]);
};
